import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, FormControl, Grid, MenuItem, Select, TextField } from '@material-ui/core';
import USPhoneInput from '../../Shared/USPhoneInput';

const styles = makeStyles((theme) => ({
  sectionSpacer: {
    height: 50,
    padding: '10px 0',
  },
  rowSpacer: {
    height: 30,
  },
  textRowSpacer: {
    [theme.breakpoints.up('sm')]: {
      height: 50,
    },
  },
  textRowLabelSpacer: {
    [theme.breakpoints.down('md')]: {
      height: 30,
      paddingTop: 5,
    },
    [theme.breakpoints.up('md')]: {
      height: 50,
      paddingTop: 8,
    },
  },
  [theme.breakpoints.down('xs')]: {
    textField: {
      fontSize: '0.75rem',
    },
    root: {
      '& .MuiFormLabel-root': {
        fontSize: '0.75rem',
      },
    },
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  alignPrintedContent: {
    lineHeight: '25px',
    verticalAlign: 'top',
  },
  sectionTitle: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.00rem',
      fontWeight: 600,
      margin: '8px 0',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.10rem',
      fontWeight: 600,
      margin: '15px 0',
    },
  },
  sectionSubTitle: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.80rem',
      fontWeight: 600,
      margin: '2px 0',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '0.90rem',
      fontWeight: 600,
      margin: '5px 0',
    },
  },
}));

export default function HealthInsurancePlanV2(props) {
  const { form, setForm, disabled, saveHealthInsuranceTask } = props;

  const classes = styles();

  return (
    <Box sx={{ width: '90%' }}>
      <Grid container direction="row" className={classes.sectionSpacer}>
        <Grid item xs={12} align="left">
          <section align="left" className={classes.sectionSubTitle}>
            Post-Graduation Health Insurance Plan
          </section>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={false} md={1} lg={1} />
        <Grid item xs={12} md={6} lg={3} className={classes.textRowLabelSpacer}>
          <label>Health Insurance Plan</label>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} className={classes.textRowSpacer}>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={form.healthInsPlan}
              onChange={(event) => saveHealthInsuranceTask(event.target.value)}
              disabled={disabled}
            >
              <MenuItem value="Medicaid">Medicaid</MenuItem>
              <MenuItem value="Private Insurance">Private Insurance</MenuItem>
              <MenuItem value="Insurance through Employer">Insurance through Employer</MenuItem>
              <MenuItem value="None">None</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <summary className={classes.printedContent}>{form.healthInsPlan || null}</summary>
      {form.healthInsPlan !== 'None' && (
        <>
          <Grid container direction="row" className={classes.unprintedContent}>
            <Grid item xs={false} md={1} lg={1} />
            <Grid item xs={12} md={6} lg={3} className={classes.textRowLabelSpacer} style={{ marginTop: '-10px', marginBottom: '20px' }}>
              <label>What does the health insurance plan cover? (medical, mental health, dental, etc.)</label>
            </Grid>
            <Grid item xs={12} md={6} lg={8} className={classes.textRowSpacer}>
              <FormControl fullWidth>
                <TextField
                  id="auto-insurance-coverage"
                  size="small"
                  hiddenLabel
                  variant="outlined"
                  value={form.healthInsCover}
                  onChange={(event) => setForm({ ...form, healthInsCover: event.target.value })}
                  disabled={disabled}
                  InputProps={{ classes: { input: classes.textField } }}
                  inputProps={{ maxLength: 250 }}
                  className={classes.root}
                />
              </FormControl>
            </Grid>
          </Grid>
          <div className={classes.printedContent}>
            <Grid container direction="row" className={classes.printedContent}>
              <Grid item xs={6}>
                <label className={classes.alignPrintedContent}>
                  What will my health insurance plan cover? (medical, mental health, dental, etc.)?
                </label>
              </Grid>
              <Grid item xs={6}>
                <summary className={classes.alignPrintedContent}>{form.healthInsCover || null}</summary>
              </Grid>
            </Grid>
          </div>
        </>
      )}

      <Grid container direction="row" className={classes.unprintedContent} style={{ marginTop: '5px' }}>
        <Grid item xs={false} md={1} lg={1} />
        <Grid item xs={12} md={6} lg={3} className={classes.textRowLabelSpacer}>
          <label htmlFor="primary-doctor">Primary Care Physician Name</label>
        </Grid>
        <Grid item xs={12} md={6} lg={3} className={classes.textRowSpacer}>
          <FormControl fullWidth>
            <TextField
              id="primary-doctor"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form.primaryDoctor}
              onChange={(event) => setForm({ ...form, primaryDoctor: event.target.value })}
              disabled={disabled}
              InputProps={{ classes: { input: classes.textField } }}
              inputProps={{ maxLength: 100 }}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={4}>
          <label className={classes.alignPrintedContent} htmlFor="primary-doctor">
            Primary Care Physician Name
          </label>
        </Grid>
        <Grid item xs={8}>
          <summary className={classes.alignPrintedContent}>{form.primaryDoctor || null}</summary>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={false} md={1} lg={1} />
        <Grid item xs={12} md={6} lg={3} className={classes.textRowLabelSpacer}>
          <label htmlFor="primary-doctor-phone">Primary Care Physician Phone Number</label>
        </Grid>
        <Grid item xs={12} md={6} lg={3} className={classes.textRowSpacer}>
          <USPhoneInput
            id="primary-doctor-phone"
            label="Primary Care Physician Phone Number"
            showLabel={false}
            value={form.primaryDoctorPhone || ''}
            onChange={(val) => setForm({ ...form, primaryDoctorPhone: val })}
            disabled={disabled}
            InputProps={{ classes: { input: classes.textField } }}
            size="small"
          />
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={4}>
          <label className={classes.alignPrintedContent} htmlFor="primary-doctor-phone">
            Primary Care Physician Phone Number
          </label>
        </Grid>
        <Grid item xs={8}>
          <summary className={classes.alignPrintedContent}>{form.primaryDoctorPhone || null}</summary>
        </Grid>
      </Grid>

      <Grid container direction="row" className={classes.unprintedContent} style={{ marginTop: '10px' }}>
        <Grid item xs={false} md={1} lg={1} />
        <Grid item xs={12} md={6} lg={3} className={classes.textRowLabelSpacer}>
          <label htmlFor="dentist">Name of Dentist</label>
        </Grid>
        <Grid item xs={12} md={6} lg={3} className={classes.textRowSpacer}>
          <FormControl fullWidth>
            <TextField
              id="dentist"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form.dentist}
              onChange={(event) => setForm({ ...form, dentist: event.target.value })}
              disabled={disabled}
              InputProps={{ classes: { input: classes.textField } }}
              inputProps={{ maxLength: 100 }}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={4}>
          <label className={classes.alignPrintedContent} htmlFor="dentist">
            Name of Dentist
          </label>
        </Grid>
        <Grid item xs={8}>
          <summary className={classes.alignPrintedContent}>{form.dentist || null}</summary>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={false} md={1} lg={1} />
        <Grid item xs={12} md={6} lg={3} className={classes.textRowLabelSpacer}>
          <label htmlFor="dentist-phone">Dentist Phone Number</label>
        </Grid>
        <Grid item xs={12} md={6} lg={3} className={classes.textRowSpacer}>
          <USPhoneInput
            id="dentist-phone"
            showLabel={false}
            label="Dentist Phone Number"
            value={form.dentistPhone || ''}
            onChange={(val) => setForm({ ...form, dentistPhone: val })}
            disabled={disabled}
            InputProps={{ classes: { input: classes.textField } }}
            size="small"
          />
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={4}>
          <label className={classes.alignPrintedContent} htmlFor="dentist-phone">
            Dentist Phone Number
          </label>
        </Grid>
        <Grid item xs={8}>
          <summary className={classes.alignPrintedContent}>{form.dentistPhone || null}</summary>
        </Grid>
      </Grid>

      <Grid container direction="row" className={classes.unprintedContent} style={{ marginTop: '10px' }}>
        <Grid item xs={false} md={1} lg={1} />
        <Grid item xs={12} md={6} lg={3} className={classes.textRowLabelSpacer}>
          <label htmlFor="mental-health">Mental Health Provider Name</label>
        </Grid>
        <Grid item xs={12} md={6} lg={3} className={classes.textRowSpacer}>
          <FormControl fullWidth>
            <TextField
              id="mental-health"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form.therapist}
              onChange={(event) => setForm({ ...form, therapist: event.target.value })}
              disabled={disabled}
              InputProps={{ classes: { input: classes.textField } }}
              inputProps={{ maxLength: 100 }}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={4}>
          <label className={classes.alignPrintedContent} htmlFor="mental-health">
            Mental Health Provider Name
          </label>
        </Grid>
        <Grid item xs={8}>
          <summary className={classes.alignPrintedContent}>{form.therapist || null}</summary>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={false} md={1} lg={1} />
        <Grid item xs={12} md={6} lg={3} className={classes.textRowLabelSpacer}>
          <label htmlFor="mental-health-phone">Mental Health Provider Phone Number</label>
        </Grid>
        <Grid item xs={12} md={6} lg={3} className={classes.textRowSpacer}>
          <USPhoneInput
            id="mental-health-phone"
            showLabel={false}
            label="Mental Health Provider Phone Number"
            value={form.therapistPhone || ''}
            onChange={(val) => setForm({ ...form, therapistPhone: val })}
            disabled={disabled}
            InputProps={{ classes: { input: classes.textField } }}
            size="small"
          />
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={4}>
          <label className={classes.alignPrintedContent} htmlFor="mental-health-phone">
            Mental Health Provider Phone Number
          </label>
        </Grid>
        <Grid item xs={8}>
          <summary className={classes.alignPrintedContent}>{form.therapistPhone || null}</summary>
        </Grid>
      </Grid>
    </Box>
  );
}

HealthInsurancePlanV2.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  disabled: PropTypes.bool,
  saveHealthInsuranceTask: PropTypes.func,
};
